import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery } from '../../utils/createAuthenticatedBaseQuery';
import { getWorkflowsApiBaseUrl } from '../../utils/runtimeConfig';

const apiBaseUrl = getWorkflowsApiBaseUrl();

/**
 * Workflow API shell — endpoints are injected from workflowQueries.ts and workflowMutations.ts.
 * This keeps each file focused while sharing a single reducer, middleware, and cache.
 */
export const workflowApi = createApi({
  reducerPath: 'workflowApi',
  baseQuery: createAuthenticatedBaseQuery(apiBaseUrl, 'Workflow API'),
  tagTypes: ['Workflow', 'WorkflowList', 'WorkflowDimensions'],
  endpoints: () => ({}),
});
